import { render, staticRenderFns } from "./vuex-search-field.vue?vue&type=template&id=58795db4"
import script from "./vuex-search-field.vue?vue&type=script&lang=js"
export * from "./vuex-search-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports